import {
  getArtists,
  getAlbums,
  setArtist,
  getTracks,
  getAsset,
  getGenres,
  setAlbum,
  setTrack,
  setAsset,
  setMusicFile
} from '../api/music'

import defaultImage from './data/iconArtist';
import defaultImgAlbum from './data/iconDisk';

export function CreateArtist(name){
  return newArtist({ art_id: null, art_name : name, art_description : ""});
}


function newArtist(a) {
  a.old = {...a};   

  a.albums = null;
  a.selected = false;
  a.modified = function(){
    return this.art_name !== this.old.art_name ||
    this.art_description !== this.old.art_descrption;
  };
  a.undo = function(){
    this.art_name = this.old.art_name;
    this.art_description = this.old.art_descrption;
  };
  a.saveForUndo = function (){
    this.old.art_id = this.art_id;
    this.old.art_name = this.art_name;
  };    
  a.NameIsValid = function(){
    return textLength(this.art_name, 3);
  }
  a.NameIsValidNotExist = function(list){
    return this.NameIsValid() && notInListArtist(this, list);
  }
  a.image = defaultImage;
  a.isDefaultImage = true;    
  a.createAlbum = function (alb){
    if (!a.albums) a.albums = [];
    const count = a.albums.push(newAlbum(alb));
    return a.albums[count - 1];
  };
  return a;
}

function exist(newObj, oldObj, fieldName, fieldId){
  return newObj[fieldId] !== oldObj[fieldId] && (newObj[fieldName].toLowerCase().startsWith(oldObj[fieldName].toLowerCase())  && oldObj[fieldName].length <= newObj[fieldName].length);
}
function notInListArtist(art, list){
  if (!list) return false;
  return !(list.find((a) => exist(a, art, 'art_name', 'art_id') ));
  
}
function notInListAlbum(alb, list){
  if (!list) return false;
  return !(list.find((a) => exist(a, alb, 'alb_name', 'alb_id') ));
  
}

function newAlbum(a) {
  a.old = {...a};   
  a.tracks = null;
  a.selected = false;
  a.file = null;
  a.modified = function(){
    return this.alb_name !== this.old.alb_name ||
    this.alb_description !== this.old.alb_description ||
    this.alb_year !== this.old.alb_year ||
      !arrayEquals(this.genres, this.old.genres) || 
    this.file !== null;
  };
  a.undo = function(){
    this.alb_name = this.old.alb_name;
    this.alb_description = this.old.alb_description;
    this.alb_year = this.old.alb_year;
    this.genres = this.old.genres.slice(0);
  };
  a.isValid= function(){
    return textLength(this.alb_name, 2) && yearState(this.alb_year);
  };
  a.NameIsValid = function(list){
    return textLength(this.alb_name, 2) && notInListAlbum(this, list);
  }
  a.YearIsValid = function(){
    return yearState(this.alb_year);
  } 
  a.saveForUndo = function (){
    this.old.alb_id = this.alb_id;
    this.old.alb_name = this.alb_name;
    this.old.alb_descriiption = this.alb_description;
    this.old.alb_year = this.alb_year;
    this.old.genres = this.genres.slices(0);
  };    
  if (!a.image){
    a.image = defaultImgAlbum;
    a.isDefaultImage = true;
  } 
  else {
    a.isDefaultImage = false;
  }
  a.createTrack = function (trk){
    if (!a.tracks) a.tracks = [];
    const count = a.tracks.push(newTrack(trk, a.alb_id));
    if (!a.trackAdded) a.trackAdded = true;
    return a.tracks[count - 1];
  };
  return a;
}

function newTrack(t, alb_id){
  t.old = {...t};   
  t.alb_id = alb_id;
  t.selected = false;
  t.modified = function(){
    return this.trk_name !== this.old.trk_name ||
      this.trk_number !== this.old.trk_number ||
      this.trk_description !== this.old.trk_description ||
      this.trk_year !== this.old.trk_year ||
      this.trk_gmus_id !== this.old.trk_gmus_id;
  };
  t.undo = function() {
    this.trk_name = this.old.trk_name;
    this.trk_number = this.old.trk_number;
    this.trk_description = this.old.trk_description;
    this.trk_year = this.old.trk_year;
    this.trk_gmus_id = this.old.trk_gmus_id;
    this.trk_duration = this.old.trk_duration;
  }
  t.isValid= function(){
    return textLength(this.trk_name, 3) && yearState(this.trk_year, true);
  };
  t.NameIsValid = function(){
    return textLength(this.trk_name, 3);
  }
  t.YearIsValid = function(){
    return yearState(this.trk_year, true);
  }
  t.DurationIsValid = function(){
    return timeState(this.trk_duration);
  }
//    a.image = defaultImage;
  t.isDefaultImage = true;
  return t;
}

function arrayEquals(a, b) {
  return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
}

function textLength(value, length) {
  return !(value)? true: (value.length >= length);
}

function yearState(year, isNullable=false){
  return  /^\d{4}$/.test(year) || (isNullable && !year);
}

function timeState(time){
  const result = time.match(/^(\d{1,2}):(\d{1,2}):(\d{1,2})?$/);
  if (!result) return false;
  return (Number(result[1])> 0 || Number(result[2])> 0 || Number(result[3])> 0);

}

export async function Artists() {
  const  result = await getArtists();

  return result.map((a) => {
    return newArtist(a);
  });
}
export async function Albums(art_id) {
  const result = await getAlbums(art_id);
  return result.map((a) => {
    return newAlbum(a);
  });
}

export async function Tracks(alb_id){
  const result = await getTracks(alb_id);
  return result.map((t) => {
    return (newTrack(t, alb_id))
  }).sort((a, b) => a.trk_number-b.trk_number);
}

export async function Genres(){
  const result = await getGenres();
  return result;
}

export async function SaveArtist(artist) {
  const result = await setArtist(artist);
  return result;
}

export async function Asset(ass_id, source){
  const result = getAsset(ass_id, source);
  return result;
}

export async function SaveAlbum(art_id, album){
  const result = await setAlbum(art_id, album);
  return result;
}

export async function SaveTrack(alb_id, track){
  const result = await setTrack(alb_id, track);
  return result;
}

export async function SaveAsset(id, context, file, filename){
  const name = `${context}_${id}_${filename}`;
  const result = await setAsset(id, context, file, name);
  if (result)
    return result.id;
  return -1;
}

export async function SaveMp3(id, file, filename){
  const result = await setMusicFile(id, file, filename);
  if (result)
    return result.id;
  return -1;  
}

export async function SaveTracksOfAlbum(alb){
  alb.tracks.forEach(async (t) => {
    const r = await SaveTrack(alb.alb_id, t);
    if (r && r.length > 0) {
      t.trk_id = r[0].trk_id;
      if (t.trk_ass_id === null && t.file) {
        const f = await SaveMp3(t.trk_id, t.file, t.file.name);
        if (f >0) t.trk_ass_id = f;
      }
    }
  });
}